import { makeStyles } from '@mui/styles';
import { Colors } from '../../../../assets/styles';

export const useStyles = makeStyles({
  root: {
    '& ul': {
      padding: 0,
    },
  },
  applyFilterBtn: {
    color: Colors.Green,
  },
});